module.exports = __webpack_public_path__ + "img/coupon-bg.50e9dd1a.png";